import React from "react";
import styled from "styled-components";
import { formatPhoneNumber } from "../../../utils/formaters";
import { ReactComponent as PhoneIcon } from "../../../assets/svg/Phone.svg";
import { ReactComponent as MailIcon } from "../../../assets/svg/Email.svg";

const ContactInfoContainer = styled.div`
  display: flex;
  align-self: stretch;
  gap: 10px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const ContactIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
`;

const ContactText = styled.div`
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5em;
  color: #000000;
`;

/**
 * Details component for consent request events
 * Shows contact information (phone/email) where the request was sent
 */
const ConsentRequestDetails = ({ phone, email }) => {
  return (
    <ContactInfoContainer>
      {phone && (
        <ContactItem>
          <ContactIcon>
            <PhoneIcon />
          </ContactIcon>
          <ContactText>{formatPhoneNumber(phone)}</ContactText>
        </ContactItem>
      )}
      {email && (
        <ContactItem style={{ flex: 1 }}>
          <ContactIcon>
            <MailIcon />
          </ContactIcon>
          <ContactText>{email}</ContactText>
        </ContactItem>
      )}
    </ContactInfoContainer>
  );
};

export default ConsentRequestDetails;
